import { HIDE_LOAD, SHOW_LOAD } from './constants';

export function showLoad() {
  return {
    type: SHOW_LOAD,
  };
}

export function hideLoad() {
  return {
    type: HIDE_LOAD,
  };
}
